import { EventType } from "@omni/types/components/tracking/eventType.enum";
import { ButtonImpressionTrackingInfo } from "@omni/types/components/tracking/tracking-info/impression/buttonImpression.trackingInfo";

import {
    findClosestContext,
    getJsonPayload,
    getPageInfo,
    getUserInfo
} from "@/services/tracking/trackers/utils";
import * as TrackingService from "@/services/tracking/tracking.service";
import { TypedAnalyticsEvent } from "@/services/tracking/types/analyticsEvent";

export const track = (
    trackingInfo: Omit<ButtonImpressionTrackingInfo, "placement">,
    element: HTMLElement
) => {
    const placement = findClosestContext(element)?.name ?? "";

    const event: TypedAnalyticsEvent<ButtonImpressionTrackingInfo> = {
        event: EventType.ButtonImpression,
        payload: {
            eventData: {
                ...trackingInfo,
                placement
            },
            pageInfo: getPageInfo(),
            userInfo: getUserInfo()
        }
    };

    TrackingService.track(event);
};

export const trackElement = (element: HTMLElement) => {
    const trackingInfo = getJsonPayload(element);

    track(trackingInfo, element);
};
